<template>
  <app-content class="app-home-vue frame-page" v-if="currentTab==='Home'">
    <template v-if="currentAccountSets">
      <Row :space="24">
        <Cell width="24">
          <div class="h-panel" style="height: 230px">
            <div class="h-panel-bar">
              <div class="h-panel-title" style="font-size: 17px; color: black; font-weight: bold;">常用功能</div>
            </div>
            <Row :space="24" style="margin: 20px 10px">
              <Cell width="4">
                <div class="first-one" @click="jumpVouch('SubjectBalance')">
                  <img src="../assets/index/余额表.png" class="first-one-img"/>
                  <p>余额表</p>
                </div>
              </Cell>
              <Cell width="4">
                <div class="first-one" @click="jumpVouch('AuxiliaryAccountingBalance')">
                  <img src="../assets/index/辅助核算余额表.png" class="first-one-img"/>
                  <p>辅助核算余额表</p>
                </div>
              </Cell>
              <Cell width="4">
                <div class="first-one" @click="jumpVouch('DetailedAccounts')">
                  <img src="../assets/index/明细账.png" class="first-one-img"/>
                  <p>明细账</p>
                </div>
              </Cell>
              <Cell width="4">
                <div class="first-one" @click="jumpVouch('GeneralLedger')">
                  <img src="../assets/index/现金流量表.png" class="first-one-img"/>
                  <p>总账</p>
                </div>
              </Cell>
              <Cell width="4">
                <div class="first-one" @click="jumpVouch('zcfz')">
                  <img src="../assets/index/资产负债表.png" class="first-one-img"/>
                  <p>资产负债表</p>
                </div>
              </Cell>
              <Cell width="4">
                <div class="first-one" @click="jumpVouch('lr')">
                  <img src="../assets/index/利润表.png" class="first-one-img"/>
                  <p>利润表</p>
                </div>
              </Cell>  
            </Row>
          </div>
        </Cell>
        <!-- <Cell width="5">
          <div class="h-panel" style="height: 230px">
            <div class="h-panel-bar">
              <div class="h-panel-title" style="font-size: 17px; color: black; font-weight: bold;">凭证</div>
              <div class="h-panel-title" style="font-size: 10px;">（{{ dFormat(currentAccountSets.currentAccountDate, "YYYY/MM") }}）</div>
            </div>
            <div align="center">
              <Row :space="24" style="margin: 0 30px">
                <Cell width="12">
                    <span style="font-size: 14px; color: #666666">总数</span>
                    <p style="font-size: 20px; color: #666666">{{ voucherCount }}<b style="font-size: 12px; color: #666666">张</b></p>
                </Cell>
                <Cell width="12">
                    <span style="font-size: 14px; color: #666666">未审核</span>
                    <p style="font-size: 20px; color: #f86549">{{ unVoucherCount }}<b style="font-size: 12px; color: #666666">张</b></p>
                </Cell>
                <div>
                  <Button @click="addVouch" style="background-color: #4265d6; color: white; border-radius: 18px; width: 90%; height: 35px">新增凭证</Button>
                </div>
                <div>
                  <Button @click="checkVouch('Voucher')" style="color: #4265d6; border-color: #4265d6; border-radius: 18px; width: 90%; height: 35px; margin-top: 5px">查看凭证</Button>
                </div>
              </Row>
            </div>
          </div>
        </Cell> -->
        <!-- <Cell width="5">
          <div class="h-panel" style="height: 230px">
            <div class="h-panel-bar">
              <div class="h-panel-title" style="font-size: 17px; color: black; font-weight: bold;">发票管理</div>
            </div>
            <div>
              <Row :space="24" style="margin: 0 10px">
                <Cell width="12">
                  <div style="margin-top: 20px">
                    <div class="home-show-invoice">
                      <img src="../assets/index/进项发票.png" align="center">
                      <span style="font-size: 14px; color: #666666">进项发票</span>
                    </div>
                    <p style="font-size: 20px; color: #666666; text-align: center">{{ this.invoiceDataInfo.inputInvoice }}<b style="font-size: 14px; color: #666666">张</b></p>
                    <div style="background-color: #f5f5f5; border-radius: 4px; height: 35px; margin-top: 20px; padding: 6px 10px">
                      <span style="float: left; color: #666666">合计</span>
                      <span style="float: right; font-weight: bold">{{ this.invoiceDataInfo.inputInvoiceT }}</span>
                    </div>
                  </div>
                </Cell>
                <Cell width="12">
                  <div style="margin-top: 20px">
                    <div class="home-show-invoice">
                      <img src="../assets/index/销项发票.png">
                      <span style="font-size: 14px; color: #666666">销项发票</span>
                    </div>
                    <p style="font-size: 20px; color: #666666; text-align: center">{{ this.invoiceDataInfo.outputInvoice }}<b style="font-size: 14px; color: #666666">张</b></p>
                    <div style="background-color: #f5f5f5; border-radius: 4px; height: 35px; margin-top: 20px; padding: 6px 10px">
                      <span style="float: left; color: #666666">合计</span>
                      <span style="float: right; font-weight: bold">{{ this.invoiceDataInfo.outputInvoiceT }}</span>
                    </div>
                  </div>
                </Cell>
              </Row>
            </div>
          </div>
        </Cell> -->
      </Row>
      <Row :space="24">
        <Cell width="24">
          <div class="h-panel">
            <div style="width: 100%; margin-top: 10px">
              <Row :space="24">
                <Cell width="6">
                  <div class="home-show-image bg-orange">
                    <span class="panel-title">银行存款</span>
                    <p class="panel-amount">{{ code2.toFixed(2) }}</p>
                  </div>
                </Cell>
                <Cell width="6">
                  <div class="home-show-image bg-light-orange">
                    <span class="panel-title">库存现金</span>
                    <p class="panel-amount">{{ code1.toFixed(2) }}</p>
                  </div>
                </Cell>
                <Cell width="6">
                  <div class="home-show-image bg-blue">
                    <!-- 适应工会 -->
                    <span v-if="currentAccountSets.accountStandard  !== 'TRADE_UNION'" class="panel-title">应收账款</span>
                    <span v-if="currentAccountSets.accountStandard  == 'TRADE_UNION'" class="panel-title">其他应收账款</span>
                    <p class="panel-amount">{{ code3.toFixed(2) }}</p>
                  </div>
                </Cell>
                <Cell width="6">
                  <div class="home-show-image bg-purple">
                    <!-- 适应工会 -->
                    <span v-if="currentAccountSets.accountStandard  !== 'TRADE_UNION'" class="panel-title">应付账款</span>
                    <span v-if="currentAccountSets.accountStandard  == 'TRADE_UNION'" class="panel-title">其他应付账款</span>
                    <p class="panel-amount">{{ code4.toFixed(2) }}</p>
                  </div>
                </Cell>
              </Row>
            </div>
          </div>
        </Cell>
      </Row>
      <Row :space="24">
        <Cell width="8">
          <div class="h-panel" style="height: 335px">
            <div class="h-panel-bar">
              <div class="h-panel-title" style="font-size: 17px; color: black; font-weight: bold;">凭证</div>
              <div class="h-panel-title" style="font-size: 10px;">（{{ dFormat(currentAccountSets.currentAccountDate, "YYYY/MM") }}）</div>
            </div>
            <div align="center" style="height: 260px ;">
              <Row :space="24" style="margin: 14% 30px 0px 30px;">
                <Cell width="12">
                    <span style="font-size: 14px; color: #666666">总数</span>
                    <p style="font-size: 20px; color: #666666">{{ voucherCount }}<b style="font-size: 12px; color: #666666">张</b></p>
                </Cell>
                <Cell width="12">
                    <span style="font-size: 14px; color: #666666">未审核</span>
                    <p style="font-size: 20px; color: #f86549">{{ unVoucherCount }}<b style="font-size: 12px; color: #666666">张</b></p>
                </Cell>
                <div>
                  <Button @click="addVouch" style="background-color: #4265d6; color: white; border-radius: 18px; width: 70%; height: 35px">新增凭证</Button>
                </div>
                <div>
                  <Button @click="checkVouch('Voucher')" style="color: #4265d6; border-color: #4265d6; border-radius: 18px; width: 70%; height: 35px; margin-top: 5px">查看凭证</Button>
                </div>
              </Row>
            </div>
          </div>
        </Cell> 
        <Cell width="8">
          <div class="h-panel" style="height: 335px">
            <div class="h-panel-bar">
              <div class="h-panel-title" style="font-size: 17px; color: black; font-weight: bold;">发票管理</div>
            </div>
            <div style="height: 260px ;">
              <Row :space="24" style="margin: 14% 10px 0px 10px;">
                <Cell width="12">
                  <div style="margin-top: 20px">
                    <div class="home-show-invoice">
                      <img src="../assets/index/进项发票.png" align="center">
                      <span style="font-size: 14px; color: #666666">进项发票</span>
                    </div>
                    <p style="font-size: 20px; color: #666666; text-align: center">{{ this.invoiceDataInfo.inputInvoice }}<b style="font-size: 14px; color: #666666">张</b></p>
                    <div style="background-color: #f5f5f5; border-radius: 4px; height: 35px; margin-top: 20px; padding: 6px 10px">
                      <span style="float: left; color: #666666">合计</span>
                      <span style="float: right; font-weight: bold">{{ this.invoiceDataInfo.inputInvoiceT }}</span>
                    </div>
                  </div>
                </Cell>
                <Cell width="12">
                  <div style="margin-top: 20px">
                    <div class="home-show-invoice">
                      <img src="../assets/index/销项发票.png">
                      <span style="font-size: 14px; color: #666666">销项发票</span>
                    </div>
                    <p style="font-size: 20px; color: #666666; text-align: center">{{ this.invoiceDataInfo.outputInvoice }}<b style="font-size: 14px; color: #666666">张</b></p>
                    <div style="background-color: #f5f5f5; border-radius: 4px; height: 35px; margin-top: 20px; padding: 6px 10px">
                      <span style="float: left; color: #666666">合计</span>
                      <span style="float: right; font-weight: bold">{{ this.invoiceDataInfo.outputInvoiceT }}</span>
                    </div>
                  </div>
                </Cell>
              </Row>
            </div>
          </div>
        </Cell>
        <!-- <Cell width="16">
          <div class="h-panel" style="height: 335px" id="hPanel">
            <div class="h-panel-bar">
              <div class="h-panel-title" style="font-size: 17px; color: black; font-weight: bold;">营收统计</div>
            </div>
            <div id="BusinessChart"></div>
          </div>
        </Cell> -->
        <Cell width="8">
          <div class="h-panel" style="height: 335px">
            <div class="h-panel-bar">
              <div class="h-panel-title" style="font-size: 17px; color: black; font-weight: bold;">费用分析</div>
            </div>
            <div id="CostChart"></div>
          </div>
        </Cell>
      </Row>
    </template>
    <div class="h-panel" v-else>
      <!-- jxd后台 -->
      <div class="h-panel-bar"><span class="h-panel-title" style="font-size: 17px; color: black; font-weight: bold;">创建初始化账套</span></div>
      <div class="h-panel-body">
        <AccountForm @success="onAccountSuccess"/>
      </div>
    </div>
  </app-content>
</template>
<script>
  import revenueProfit from '../js/data/revenueProfit';
  import {mapMutations, mapState,mapGetters} from 'vuex';
  import AccountForm from "@/views/setting/account/AccountForm";
  import echarts from 'echarts';
  import accountbook from "@/api/accountbook";//查科目余额
  import manba from "manba";

  export default {
    name: 'Home',
    components: {AccountForm},
    data() {
      return {
        revenueProfitOptions: revenueProfit,
        cashData: [{name: '库存现金', value: 0}, {name: '银行存款', value: 0}, {name: '其他货币资金', value: 0}],
        costData: [{name: '销售费用', value: 0}, {name: '管理费用', value: 0}, {name: '财务费用', value: 0}],
        subjectBalance:[],//科目余额表一级科目数据jxd
        code1:0.00,
        code2:0.00,
        code3:0.00,
        code4:0.00,
        voucherCount: 0,
        unVoucherCount: 0,
        loading: false,
        datas: [],
        type: 'type1',
        cashDataInfo: {
          backCash: '0.00',
          stockCash: '0.00',
          receiveCash: '0.00',
          payCash: '0.00',
        },
        invoiceDataInfo: {
          inputInvoice: '0',
          inputInvoiceT: '0.00',
          outputInvoice: '0',
          outputInvoiceT: '0.00',
        },
        // 经营状况分析数据
        BusinessChartData: {
          dayData: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          data1Count: [0, 1, 1, 5.70, 1, 1, 1, 1, 1, 1, 1, 1],
          data2Count: [1, 2, 2, 2, 2, 2, 2, 2, 3.7, 2, 2, 2],
          data3Count: [3, 3, 3, 1, 3, 3, 3, 3, 3.6, 3, 1, 3],
          data4Count: [1, 4, 4, 4, 4, 4, 1, 4, 4, 4, 2, 4],
          data5Count: [2, 5, 2, 3, 1, 4, 5, 5, 2.2, 5, 2, 1],
        },
      };
    },
    computed: {
      ...mapState(['currentAccountSets', 'currentTab']),
      ...mapGetters(['checkoutSelect', 'localCurrency']),
      costTotal() {
        let total = 0;
        this.costData.forEach(item => {
          total += item.value;
        });
        return total.toFixed(2);
      },
      cashTotal() {
        let total = 0;
        this.cashData.forEach(item => {
          total += item.value;
        });
        return total.toFixed(2);
      }
    },
    methods: {
      ...mapMutations(['newTab']),
      addVouch() {
        this.newTab({
          title: '新增凭证',
          key: 'VoucherForm'
        })
      },
      // init() {
      //   if (this.currentAccountSets) {
      //     Promise.all([
      //       Api.home.voucherCount(),
      //       // Api.home.chart.revenueProfit(),//jxd 他在算什么
      //       Api.home.chart.cost({'accountStandard':this.currentAccountSets.accountStandard}),
      //       Api.home.chart.cash(),
      //       //查当期科目余额表，用于后续首页多一些计算项调整
      //       accountbook.loadSubjectBalance(Object.assign({
      //         showNumPrice: false
      //       }, {
      //         start: manba(this.currentAccountSets.currentAccountDate).format("YYYY-M"),
      //         end: manba(this.currentAccountSets.currentAccountDate).format("YYYY-M"),
      //         currencyId: this.localCurrency.id || '',
      //         levelStart: 1,
      //         levelEnd: 1,
      //         subjectStart: null,
      //         subjectEnd: null,
      //       })),
      //       Api.home.invoiceCount(),
      //       // 未审核凭证数量接口
      //       Api.home.unVoucherCount(),//未审核数量
      //       // 发票管理接口
      //       // Api.home.queryInvoiceDataInfo(),
      //     ]).then((reslut) => {
      //       this.voucherCount = reslut[0].data;
      //       // this.updateRevenueProfitOptions(reslut[1].data);//jxd 他在算什么
      //       this.cashData = reslut[2].data;
      //       this.costData = reslut[1].data;
      //       // console.log(reslut[3].data)
      //       this.subjectBalance = reslut[3].data;
      //       this.subjectBalanceCalc();
      //       // console.log(this.costData)
      //       this.checkCostChart()//jxd这里调用图表
      //       this.invoiceDataInfo = reslut[4].data;
      //       // this.cashDataInfo = reslut[2].data;
      //       this.unVoucherCount = this.currentAccountSets.voucherReviewed ? reslut[5].data : 0;//未审核数量
      //       // this.invoiceDataInfo = reslut[6].data;
      //     });
      //   }
      // },

      init() {
        if (this.currentAccountSets) {
          Promise.all([
            Api.home.voucherCount(),
            // Api.home.chart.revenueProfit(),//jxd 他在算什么
            Api.home.chart.cost({'accountStandard':this.currentAccountSets.accountStandard}),
            // Api.home.chart.cash(),//这个没用，去掉
            //查当期科目余额表，用于后续首页多一些计算项调整
            accountbook.loadSubjectBalance(Object.assign({
              showNumPrice: false
            }, {
              start: manba(this.currentAccountSets.currentAccountDate).format("YYYY-M"),
              end: manba(this.currentAccountSets.currentAccountDate).format("YYYY-M"),
              currencyId: this.localCurrency.id || '',
              levelStart: 1,
              levelEnd: 1,
              subjectStart: null,
              subjectEnd: null,
            })),
            Api.home.invoiceCount(),
            // 未审核凭证数量接口
            Api.home.unVoucherCount(),//未审核数量
            // 发票管理接口
            // Api.home.queryInvoiceDataInfo(),
          ]).then((reslut) => {
            this.voucherCount = reslut[0].data;
            // this.updateRevenueProfitOptions(reslut[1].data);//jxd 他在算什么
            // this.cashData = reslut[2].data;
            this.costData = reslut[1].data;
            // console.log(reslut[3].data)
            this.subjectBalance = reslut[2].data;
            this.subjectBalanceCalc();
            // console.log(this.costData)
            this.checkCostChart()//jxd这里调用图表
            this.invoiceDataInfo = reslut[3].data;
            // this.cashDataInfo = reslut[2].data;
            this.unVoucherCount = this.currentAccountSets.voucherReviewed ? reslut[4].data : 0;//未审核数量
            // this.invoiceDataInfo = reslut[6].data;
          });
        }
      },
      //jxd计算科目余额表，取我想要的首页展示数据
      subjectBalanceCalc(){
        //目前只需要库存现金，银行存款，应收账款，应付账款就行了
        this.subjectBalance.forEach(item=>{
          if(item.subjectCode == '1001' || item.subjectCode == '101'){
            this.code1 = item.endBalance;
          }else if(item.subjectCode == '1002' || item.subjectCode == '102'){
            this.code2 = item.endBalance;
          }else if(item.subjectCode == '1122' || item.subjectCode == '113' || item.subjectCode == '135' || item.subjectCode == '112'){
            this.code3 = item.endBalance;
          }else if(item.subjectCode == '2202' || item.subjectCode == '211' || item.subjectCode == '215' || item.subjectCode == '202'){
            this.code4 = item.endBalance;
          }
        })
      },
      updateRevenueProfitOptions(chartData) {
        let lr = chartData["本年利润"];
        let zysr = chartData["主营业务收入"];
        let opt = Object.assign({}, this.revenueProfitOptions);
        if (lr) {
          Object.keys(lr).forEach(value => {
            opt.series[1].data[value - 1] = (lr[value] / 1000).toFixed(2);
          });
        }
        if (zysr) {
          Object.keys(zysr).forEach(value => {
            opt.series[0].data[value - 1] = (zysr[value] / 1000).toFixed(2);
          });
        }
        this.revenueProfitOptions = opt;
      },
      onAccountSuccess() {
        window.location.replace("/");
      },
      jumpVouch(key) {
        if (key === 'zcfz') {
          this.$store.commit('newTab', {key: 'ReportView:' + key, title: "资产负债表", params: {reportId: 'zcfz', dimension: ''}})
        } else if (key === 'lr') {
          this.$store.commit('newTab', {key: 'ReportView:' + key, title: "利润表", params: {reportId: 'lr', dimension: ''}})
        } else if (key === 'GeneralLedger') {
          this.$store.commit('newTab', {key: key, title: "总账"})
        } else if (key === 'SubjectBalance') {
          this.$store.commit('newTab', {key: key, title: "科目余额"})
        } else if (key === 'DetailedAccounts') {
          this.$store.commit('newTab', {key: key, title: "明细账"})
        } else if (key === 'AuxiliaryAccountingBalance') {
          this.$store.commit('newTab', {key: key, title: "核算项目余额"})
        }
      },
      checkVouch(key) {
        if (key === 'Voucher') {
          this.$store.commit('newTab', {key: key, title: "凭证列表"})
        }
      },
      // checkBusinessChart() {
      //   // document.getElementById('BusinessChart').removeAttribute("_echarts_instance_");
      //   document.getElementById('BusinessChart').style.width = document.getElementById('hPanel').offsetWidth + "px"
      //   let businessChart = echarts.init(document.getElementById('BusinessChart'), 'light')
      //   businessChart.clear()
      //   businessChart.setOption({
      //     legend: {	//图表上方的图例
      //       data: ['收入', '成本', '费用', '税金', '利润']
      //     },
      //     xAxis: {
      //       type: 'category',
      //       data: this.BusinessChartData.dayData,   // x轴数据
      //       name: '',   // x轴名称
      //       nameTextStyle: {	// x轴名称样式
      //         fontWeight: 600,
      //         fontSize: 18
      //       }
      //     },
      //     yAxis: {
      //       type: 'value',
      //       name: '',   // y轴名称
      //       nameTextStyle: {	// y轴名称样式
      //         fontWeight: 600,
      //         fontSize: 18
      //       }
      //     },
      //     grid: {
      //       left: 20,
      //       right: 20,
      //       bottom: 20,
      //       top: 30,
      //       containLabel: true
      //     },
      //     tooltip: {   //鼠标放到图上的数据展示样式
      //       trigger: 'axis',
      //       axisPointer: {
      //         type: 'cross'
      //       },
      //       padding: [5, 10]
      //     },
      //     series: [	//每条折线的数据系列
      //       {
      //         name: '收入',
      //         data: this.BusinessChartData.data1Count,
      //         type: 'line',
      //         smooth: true,
      //         animationDuration: 1800,
      //         animationEasing: 'cubicInOut',
      //         itemStyle: {
      //           normal: {
      //             color: '#4565c4',
      //             lineStyle: {
      //               color: '#4565c4',
      //               width: 2
      //             }
      //           }
      //         },
      //       },
      //       {
      //         name: '成本',
      //         data: this.BusinessChartData.data2Count,
      //         type: 'line',
      //         smooth: true,
      //         animationDuration: 1800,
      //         animationEasing: 'cubicInOut',
      //         itemStyle: {
      //           normal: {
      //             color: '#64c269',
      //             lineStyle: {
      //               color: '#64c269',
      //               width: 2
      //             }
      //           }
      //         },
      //       },
      //       {
      //         name: '费用',
      //         data: this.BusinessChartData.data3Count,
      //         type: 'line',
      //         smooth: true,
      //         animationDuration: 1800,
      //         animationEasing: 'cubicInOut',
      //         itemStyle: {
      //           normal: {
      //             color: '#e2d82c',
      //             lineStyle: {
      //               color: '#e2d82c',
      //               width: 2
      //             }
      //           }
      //         },
      //       },
      //       {
      //         name: '税金',
      //         data: this.BusinessChartData.data4Count,
      //         type: 'line',
      //         smooth: true,
      //         animationDuration: 1800,
      //         animationEasing: 'cubicInOut',
      //         itemStyle: {
      //           normal: {
      //             color: '#c054de',
      //             lineStyle: {
      //               color: '#c054de',
      //               width: 2
      //             }
      //           }
      //         },
      //       },
      //       {
      //         name: '利润',
      //         data: this.BusinessChartData.data5Count,
      //         type: 'line',
      //         smooth: true,
      //         animationDuration: 1800,
      //         animationEasing: 'cubicInOut',
      //         itemStyle: {
      //           normal: {
      //             color: '#e00425',
      //             lineStyle: {
      //               color: '#e00425',
      //               width: 2
      //             }
      //           }
      //         },
      //       }
      //     ],
      //   })
      // },
      checkCostChart() {
        // console.log(this.costData)
        // document.getElementById('CostChart').removeAttribute("_echarts_instance_");
        let costChart = echarts.init(document.getElementById('CostChart'))
        costChart.clear()
        costChart.setOption({
          tooltip: {
            trigger: 'item'
          },
          legend: {
            orient: 'horizontal',
            left: 'center',
            top: '3%',
            textStyle: {
              fontSize: 16,
              color: '#747474',
              padding:[3, 3]
            }
          },
          graphic: {
            type: "text",
            left: "47%",
            top: "45%",
            data: [12],
            style: {
              text: String(
                      this.costData.reduce((sum, item, index, array)=>{
                        return sum + item.value
                      }, 0.00)
              ).replace(/(\d)(?=(?:\d{6})+$)/g, '$1.') + "\n\n" +  "合计",
              textAlign: "center",
              fill: "#333",
              fontSize: 15,
            }
          },
          color: ['#4499ec', '#2ee261', '#efc541'],
          series: [
            {
              name: '费用分析',
              type: 'pie',
              center: ['50%', '50%'],
              radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              label: {
                show: true,
                formatter(param) {
                  return param.value;
                }
              },
              labelLine: {
                show: true
              },
              data: this.costData
            }
          ]
        })
      }
    },
    created() {
      const currentTab = localStorage.getItem("currentTab")
      if (!currentTab) {
        this.$nextTick(() => {
          // this.checkBusinessChart()
          this.checkCostChart()
        })
      }
      this.init();
      // console.log(this.currentAccountSets) 这里面存储的是账套的信息jxd
    },
    mounted() {
      const currentTab = localStorage.getItem("currentTab")
      if (currentTab && JSON.parse(currentTab).key === 'Home') {
        // this.checkBusinessChart()
        this.checkCostChart()
      }
    }
  };
</script>

<style lang="less" scoped>
  .first-one {
    cursor: pointer;
    text-align: center;

    &:hover {
      color: #f60 !important;
    }
  }

  .first-one-img {
    margin: auto;
  }

  .h-panel-body {
    ::v-deep .el-progress-bar__innerText {
      color: #000000;
    }
  }

  .el-divider--vertical {
    display: inline-block;
    width: 1px;
    height: 80px;
    margin-top: 35px;
    vertical-align: middle;
    position: relative;
  }

  .el-divider-horizontal {
    display: block;
    height: 1px;
    width: 100%;
    border-top: 1px var(--el-border-color) var(--el-border-style);
  }

  .home-show-image.bg-orange {
    background-image: url("../assets/index/银行存款.png");
  }

  .home-show-image.bg-light-orange {
    background-image: url("../assets/index/库存现金.png");
  }

  .home-show-image.bg-blue {
    background-image: url("../assets/index/应收账款.png");
  }

  .home-show-image.bg-purple {
    background-image: url("../assets/index/应付账款.png");
  }

  .home-show-image {
    width: 90%;
    height: 140px;
    display: inline-block;
    border-radius: 4px;
    box-shadow: 0px 1px 8px 0px rgba(196, 196, 196, 0.5);
    box-sizing: border-box;
    padding: 24px;
    background-size: 40%;
    background-position: 90% 50%;
    background-repeat: no-repeat;
    cursor: pointer;
    transition: all 0.3s;
    margin: 0 20px;
  }

  .home-show-image:hover {
    transform: scale(1.08);
  }

  .panel-title {
    font-size: 16px;
    color: #999;
  }

  .panel-amount {
    font-size: 22px;
    color: #999;
    margin-top: 20px;
  }

  .home-show-invoice {
   text-align: center;
    img {
      height: 18px;
      display: inline;
      vertical-align: sub;
    }
  }

  #BusinessChart{
    width: 100%;
    height: 290px;
  }

  #CostChart{
    width: 100%;
    height: 290px;
  }

  .progress-bar{
    display:inline-block;
    width: 100%;
    box-sizing: border-box; /* 盒模型的方式 */
    margin-top: 12px;
    margin-bottom: 18px;
  }

  .progress-bar-outer{
    width: 100%;
    border-radius: 15px;
    background-color: #e1f0ff;
    height:30px;
    align-items: center;
    display: flex;
  }

  .progress-text{
    font-size: 12px;
    display: inline-block;
    vertical-align: middle;
    position: absolute;
    margin-left: 50%;
  }

  .progress-bar-inner{
    border-radius: 15px 15px 15px 15px;
    height: 100%;
    transition: width 0.6s ease;
    text-align: right;
    line-height: 80%;
  }


</style>

